import { API_BASE_URL } from '../services/api';

export const downloadCertificate = async (certificateId) => {
    const storedTokens = localStorage.getItem('auth_tokens');
    let accessToken = null;
    
    if (storedTokens) {
        try {
            const { access_token } = JSON.parse(storedTokens);
            accessToken = access_token;
        } catch (error) {
            console.error('Error parsing stored auth tokens:', error);
        }
    }
    
    const url = `${API_BASE_URL}/certificates/${certificateId}/download`;
    const headers = {};
    
    if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
    }
    
    try {
        const response = await fetch(url, { headers });
        
        if (!response.ok) {
            throw new Error('Failed to download certificate');
        }
        
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `certificate-${certificateId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        console.error('Error downloading certificate:', error);
        throw error;
    }
};

